import { defineComponent as _defineComponent } from 'vue'
import { computed, useAsync, useContext, useStore } from '@nuxtjs/composition-api';
import TLinkButton from '~/components/atoms/t-link-button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTrendingTopics',
  setup(__props) {

const store = useStore();

const { localePath, i18n } = useContext();

useAsync(async () => {
  await store.dispatch('loadTrendingTopics', { country: i18n.locale });
});

const trendingTopics = computed(() => store.getters.trendingTopics);

return { __sfc: true,store, localePath, i18n, trendingTopics, TLinkButton }
}

})